/**
 * Form.Item `normalize` helpers that block whitespace as the user types.
 */

/** Removes every whitespace character — for fields that never contain spaces
 * (email, password, OTP). Blocks leading, trailing and internal spaces. */
export const stripWhitespace = (value?: string): string | undefined =>
  value?.replace(/\s/g, "");

/** Removes only leading whitespace — for fields that allow internal spaces
 * (e.g. full name). Trailing space is trimmed on submit. */
export const stripLeadingWhitespace = (value?: string): string | undefined =>
  value?.replace(/^\s+/, "");
